import { EventSource } from './node_modules-eventsource-dist-index.js';
import { getSalesforceMessagingUrl, getOrganizationId, getJwt } from './src-utils-miaw-chat-config.js';

let eventSource;
const handleEventSourceListeners = (listenerOperationName, eventListenerMap) => {
  if (typeof eventSource !== "object") {
    throw new Error(`Expected EventSource object to be a valid object, but received: ${eventSource}`);
  }
  if (!listenerOperationName.length) {
    throw new Error(`Expected a valid string to either add or remove event listeners, but received: ${listenerOperationName}`);
  }
  Object.entries(eventListenerMap).forEach((entry) => {
    const [eventName, eventHandler] = entry;
    if (typeof eventName !== "string") {
      throw new Error(`Expected event listener name parameter to be a valid string, but received: ${eventName}.`);
    }
    if (eventName.trim().length < 1) {
      throw new Error(`Expected event listener name parameter to be a string with length greater than 0, but received: ${eventName}.`);
    }
    if (typeof eventHandler !== "function") {
      throw new Error(`Expected event listener handler parameter to be a function, but received: ${eventHandler}.`);
    }
    eventSource?.[listenerOperationName](eventName, eventHandler);
  });
  eventSource.onerror = (e) => {
    console.error("[EventSource] Error", e);
  };
};
const createEventSource = (fullApiPath, eventListenerMap) => {
  if (typeof fullApiPath !== "string" || !fullApiPath.length) {
    throw new Error(`Expected full API path parameter to be a valid string, but received: ${fullApiPath}.`);
  }
  if (typeof eventListenerMap !== "object") {
    throw new Error(`Expected event listener map parameter to be a valid object map, but received: ${eventListenerMap}.`);
  }
  const resolveEventSource = (resolve, reject) => {
    try {
      if (eventSource) {
        eventSource.close();
        eventSource = void 0;
      }
      eventSource = new EventSource(fullApiPath, {
        fetch: (input, init) => fetch(input, {
          ...init,
          headers: {
            ...init?.headers,
            Authorization: "Bearer " + getJwt(),
            "X-Org-ID": getOrganizationId()
            //   'Last-Event-ID': getLastEventId()
          }
          // heartbeatTimeout: 90000,
        })
      });
      eventSource.onopen = () => {
        handleEventSourceListeners("addEventListener", eventListenerMap);
        resolve();
      };
      eventSource.onerror = (err) => {
        console.error("[EventSource] Error", err);
        reject(err);
      };
    } catch (error) {
      reject(error);
    }
  };
  return new Promise(resolveEventSource);
};
const subscribeToEventSource = (eventListenerMap) => {
  const messagingUrl = getSalesforceMessagingUrl();
  if (!messagingUrl) {
    return Promise.reject(new Error(`Expected a valid Messaging URL to establish a connection to the Event Source, but instead received ${messagingUrl}`));
  }
  return new Promise((resolve, reject) => {
    try {
      createEventSource(getSalesforceMessagingUrl().concat(`/eventrouter/v1/sse?_ts=${Date.now()}`), eventListenerMap).then(resolve, (error) => {
        reject(error);
      }).catch((error) => {
        reject(error);
      });
    } catch (error) {
      reject(error);
    }
  });
};
const closeEventSource = () => {
  return new Promise((resolve, reject) => {
    try {
      if (eventSource) {
        eventSource.close();
        eventSource = void 0;
      }
      resolve();
    } catch (error) {
      reject(error);
    }
  });
};

export { closeEventSource, createEventSource, subscribeToEventSource };
//# sourceMappingURL=src-utils-miaw-event-source-utils.js.map
